import * as React from 'react';
import { connect } from 'react-redux';

import NotFound from 'components/not-found/NotFound';
import Page from 'components/page/Page';

import ClientApprovalWrapper from '../components/client-approval-wrapper/ClientApprovalWrapper';

import ProposalApprovePage from 'modules/proposal/pages/proposal-approve-page/ProposalApprovePage';
import SharedAccessOutfitsPage from 'modules/shared-access-outfits/pages/SharedAccessOutfitsPage';
import SharedAccessProductListPage from 'modules/shared-access-product-list/pages/SharedAccessProductListPage';

import { __t, applyTranslations } from 'utils/language';

import type { SharedAccessMeta } from 'types';
import type { Dispatch } from 'redux';

type StateProps = {
  meta: SharedAccessMeta
};

type Props = {
  // eslint-disable-next-line react/no-unused-prop-types
  dispatch: Dispatch // added by redux connect
} & StateProps;

applyTranslations(require('locales/common/collabary-common.i18n.json'));

const SharedAccessPage = (
  {
    meta
  }: Props
): JSX.Element => {
  switch (meta?.type) {
    case 'content-approval':
      return (
        <Page documentTitle={__t('shared_access_client_content_approval_page_title')}>
          <ClientApprovalWrapper />
        </Page>
      );
    case 'creator-approval':
      return <ProposalApprovePage />;
    case 'campaign-outfit-list':
      return <SharedAccessOutfitsPage />;
    case 'product-list':
      return <SharedAccessProductListPage />;
    default:
      return (
        <Page documentTitle={__t('page_not_found')}>
          <NotFound />
        </Page>
      );
  }
};

const mapStateToProps = ({ sharedAccess }): StateProps => ({
  meta: sharedAccess.meta
});

export default connect(mapStateToProps)(SharedAccessPage);
